var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChild24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.741 42.532a.816.816 0 00-.268-.616l-.319-.319-6.256-6.296a.995.995 0 00-1.304 0l-.447.447a.995.995 0 00.08 1.383l4.137 4.128H3.233a.756.756 0 01-.746-.746V1.243a1.243 1.243 0 10-2.487 0v39.27a3.233 3.233 0 003.233 3.233h9.131l-4.227 4.227a.905.905 0 000 1.284l.447.447a.864.864 0 001.224.08l6.317-6.287.358-.278a.855.855 0 00.258-.687z"
  })));
}
export default SvgIconChild24;